import { usePermissions } from '../../auth/permissions';
import {
	useTranslate,
	List, Datagrid, TextField,
	EditButton, ShowButton,
} from 'react-admin';
import { Helmet } from 'react-helmet-async';
import { LIST_ITEM_MAX_COUNT } from '../../config';

export const UserList = () => {
	const translate = useTranslate();
	const { isAdmin, isUser } = usePermissions();
	
	const pageTitle = translate('resources.user.list');
	const systemName = translate('system.name');
	
	return (
		<>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<List title={pageTitle} perPage={LIST_ITEM_MAX_COUNT} queryOptions={{ meta: { mode: 'kanri' } }}>
				<Datagrid rowClick={() => false} bulkActionButtons={false} isRowSelectable={() => false}>
					<TextField source="id" />
					<TextField source="name" />
					{isAdmin && <EditButton />}
					{isUser && <ShowButton />}
				</Datagrid>
			</List>
		</>
	);
};

export default UserList;